import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Iframe recursion guard — prevent infinite embed loops
if (window.self !== window.top) {
  try {
    if (window.location.hostname === window.parent.location.hostname) {
      document.body.innerHTML = '<p style="color:#fff;padding:20px;">Recursion blocked</p>';
      throw new Error('Iframe recursion detected');
    }
  } catch (e) {
    if (e.message === 'Iframe recursion detected') throw e;
    // Cross-origin access blocked — this is fine, means it's a legitimate external embed
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
